// extracted by mini-css-extract-plugin
module.exports = {"root":"planList_root__3beJJ","prev":"planList_prev__2kh8z","next":"planList_next__Z7Euc"};